const { log, info, warn, error, group, groupEnd } = console;
export const Logger = { log, info, warn, error, group, groupEnd };
